import CardWrapper from '@components/UI/CardWrapper';
import Typography from '@mui/material/Typography';
import { useRequiredDocuments } from '@pages/CompanyProfile/hooks/useRequiredDocuments';
import { MainData } from '@services/requests/companyProfileService/types/mainData';
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import {
  CompanyProfileExtendedFormFields,
  CompanyProfileFormFields,
} from '../../CompanyProfileModulesWrapper/types';
import { RequiredDocumentItem } from './RequiredDocumentItem';
import { RequiredDocumnetsModuleStyledContainer } from './StyledComponents';

interface RequiredDocumentsModuleProps {
  defaultFormState: CompanyProfileFormFields & CompanyProfileExtendedFormFields;
  form: UseFormReturn<
    CompanyProfileFormFields & CompanyProfileExtendedFormFields,
    any,
    CompanyProfileFormFields & CompanyProfileExtendedFormFields
  >;
  mainData: MainData;
  isInspection: boolean;
}

function RequiredDocumnetsModule({
  form,
  defaultFormState,
  mainData,
  isInspection,
}: RequiredDocumentsModuleProps) {
  const { watch } = form;

  const { fields } = mainData.sections.documents;

  const currentFormState = watch();

  const requiredDocuments = useRequiredDocuments({ currentFormState, defaultFormState });

  if (!requiredDocuments.length) {
    return null;
  }

  return (
    <RequiredDocumnetsModuleStyledContainer>
      <CardWrapper sx={{ padding: '25px 40px' }} className="card">
        <Typography variant={'h3'} className={'module-title'}>
          {mainData.sections.documents.caption}:
        </Typography>
        <div className="document-list">
          {requiredDocuments.map((document) => (
            <RequiredDocumentItem
              key={document}
              document={document}
              fields={fields}
              form={form}
              isInspection={isInspection}
            />
            // <div {...getRootProps({ className: `upload-file-btn` })} key={document}>
            //   <span className="upload-file-btn__label">{fields[document].title}</span>
            //   <input {...getInputProps()} />
            //   <PlusIcon />
            // </div>
          ))}
          {/* <TextField
            fullWidth
            className="document-file"
            size={'medium'}
            disabled
            type={'text'}
            label={t('CompanyProfile:Representative.FullName')}
            variant="outlined"
            value={'Выписка Онлог Систем.pdf'}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label={'reset document file'}
                    //   onClick={() => setShowCurrentPassword((prev) => !prev)}
                    edge="end"
                    size="small"
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          /> */}
        </div>
      </CardWrapper>
    </RequiredDocumnetsModuleStyledContainer>
  );
}
export { RequiredDocumnetsModule };
